import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "drag-handle",
  "use": "drag-handle-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"drag-handle\"><path d=\"M40 18H8v4h32v-4zM8 30h32v-4H8v4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol